import factory from '../requestFactory';
import store from '@/store'

export default (payload) => {
    let params = {
        patient_id: store.getters.patient.id,
        base_encode:true
    }
    let visit_id = payload.visit_id

    return factory()
        .get(`/patient/visits/${visit_id}/document`, {params:params})

};
